import { useState } from 'react';

export const useValidation = () => {
  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(true);

  const validate = (formData, fieldName) => {
    let tempErrors = { ...errors };
    let isValid = true;

    if (!fieldName) {
      Object.keys(formData).forEach((field) => {
        if (!formData[field]) {
          tempErrors[field] = 'This field is required';
          isValid = false;
        }
      });
    }

    if (fieldName && !formData[fieldName]) {
      tempErrors[fieldName] = 'This field is required';
      isValid = false;
    } else {
      delete tempErrors[fieldName];
    }

    if (formData.email && (fieldName === 'email' || !fieldName)) {
      if (!/\S+@\S+\.\S+/.test(formData.email)) {
        tempErrors.email = 'Email is not valid';
        isValid = false;
      } else {
        delete tempErrors.email;
      }
    }

    setErrors(tempErrors);
    setIsFormValid(isValid);
    return { isValid, errors: tempErrors };
  };

  return { validationErrors: errors, isFormValid, validate };
};
